import { ComponentType, ReactNode } from 'react'
import styled from 'styled-components'

import PlaceholderCard from '../../cards/PlaceholderCard'

const Wrapper = styled.div`
  margin: 0 -14px;
  overflow: hidden;
`

const Container = styled.div`
  display: flex;
`

const Slide = styled.div`
  padding: 0 14px;
  flex: 0 0 calc(100% / 3);
  min-width: 0;
  box-sizing: border-box;
`

type SliderProps<T> = {
  items: T[]
  ItemComponent: ComponentType<{ item: T }>
  emblaRef: (node: HTMLDivElement | null) => void
  loadingPlaceholder: ReactNode
  slideCount: number
}

const Slider = <T extends Record<'id', string>>({
  emblaRef,
  items,
  ItemComponent,
  loadingPlaceholder = <PlaceholderCard portrait={false} />,
  slideCount,
}: SliderProps<T>) => (
  <Wrapper ref={emblaRef}>
    <Container>
      {Array.from({ length: slideCount }, (_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Slide key={i}>
          {i < items.length ? (
            <ItemComponent item={items[i]} />
          ) : (
            <>{loadingPlaceholder}</>
          )}
        </Slide>
      ))}
    </Container>
  </Wrapper>
)

export default Slider
